import React from 'react';
import TopicHeader from './TopicHeader';
import TopicButton from './TopicButton';
import CloseButton from './CloseButton';
import { Card, CardContent } from '@/Components/ui/card';
import { Stack } from '@/Components/ui/layout';

function InterviewTopic() {
  return (
    <div className="bg-slate-900 flex flex-col overflow-hidden w-[125%] -ml-[12.9%]">
      <div className="flex flex-col relative min-h-[10px] w-full overflow-hidden items-center justify-center py-[375px] px-2.5 -mt-[200px]">
        <img 
          className="absolute inset-0 h-full w-full object-cover object-center"
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/53d26c2500299d8ace7865a757d37ff395949a1b3492e9edc20ce79e65298f14?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
          alt="Background pattern"
        />
        <Card className="relative items-center rounded-xl bg-white flex mb-[-134px] w-[872px] max-w-full flex-col justify-start p-10">
          <CardContent className="self-center z-0 flex w-full max-w-[792px] flex-col justify-start p-0">
            <Stack spacing="md">
              <TopicHeader />
              <TopicButton />
            </Stack>
          </CardContent>
          <CloseButton />
        </Card>
      </div>
    </div>
  );
}

export default InterviewTopic;